import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const LIST: AppRouteRecordRaw = {
  path: '/promotion', // 推广 
  name: 'promotion',
  component: DEFAULT_LAYOUT,
  meta: {
    locale: 'menu.promotion',
    requiresAuth: true,
    icon: 'icon-relation',
    order: 6,
  },
  children: [
    {
      path: 'personManage', // The midline path complies with SEO specifications
      name: 'personManage',
      component: () => import('@/views/promotion/person/index.vue'),
      meta: {
        locale: 'menu.personManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    // {
    //   path: 'subordinateManage', // The midline path complies with SEO specifications
    //   name: 'subordinateManage',
    //   component: () => import('@/views/promotion/subordinate/index.vue'),
    //   meta: {
    //     locale: 'menu.subordinateManage',
    //     requiresAuth: true,
    //     roles: ['*'],
    //   },
    // },
    {
      path: 'incomeManage', // The midline path complies with SEO specifications
      name: 'incomeManage',
      component: () => import('@/views/promotion/income/index.vue'),
      meta: {
        locale: 'menu.incomeManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
    {
      path: 'settlementManage', // The midline path complies with SEO specifications
      name: 'settlementManage',
      component: () => import('@/views/promotion/settlement/index.vue'),
      meta: {
        locale: 'menu.settlementManage',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default LIST;
